import {
	getLocalStorageItemAsString,
	setLocalStorageItem,
} from '@atlassian/search-common/local-storage';

const THIRD_PARTY_QUERY_SUGGESTIONS_DISMISS_KEY =
	'atlassian.unified-search.third-party-query-suggestions-dismissed';

/**
 * @returns whether the user has dismissed the third-party query suggestions
 */
export const isThirdPartyQuerySuggestionsDismissed = (): boolean => {
	const dismissed = getLocalStorageItemAsString(THIRD_PARTY_QUERY_SUGGESTIONS_DISMISS_KEY);
	return dismissed === 'true';
};

/**
 * Sets the third-party query suggestions dismissed state to true
 */
export const dismissThirdPartyQuerySuggestions = (): void => {
	setLocalStorageItem(THIRD_PARTY_QUERY_SUGGESTIONS_DISMISS_KEY, 'true');
};
